import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { Inbox } from "lucide-react";

const STATUSES = ["NEW", "CONTACTED", "QUALIFIED", "WON", "LOST"];

export default function PlatformLeads() {
  const [leads, setLeads] = useState([]);
  const load = async () => { const { data } = await api.get("/platform/leads"); setLeads(data); };
  useEffect(() => { load(); }, []);

  const update = async (id, status) => {
    try { await api.patch(`/platform/leads/${id}`, { status }); toast.success("Updated"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="admin-platform-leads">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black flex items-center gap-2"><Inbox className="w-7 h-7 text-primary" /> Subscription Leads</h1>
        <p className="text-muted-foreground">Companies that configured a plan on the marketing site.</p>
      </div>
      <div className="surface-card p-4 overflow-x-auto">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Company</TableHead><TableHead>Contact</TableHead><TableHead>Portal</TableHead>
            <TableHead>Plan</TableHead><TableHead className="text-right">Quote</TableHead>
            <TableHead>Created</TableHead><TableHead>Status</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {leads.map((l) => (
              <TableRow key={l.id} data-testid={`lead-row-${l.id}`}>
                <TableCell><div className="font-medium">{l.company_name}</div><div className="text-xs text-muted-foreground">{l.email}</div></TableCell>
                <TableCell>{l.contact_name || "—"}<div className="text-xs text-muted-foreground">{l.phone}</div></TableCell>
                <TableCell><Badge variant="outline">{l.portal}</Badge></TableCell>
                <TableCell><Badge>{l.plan_code} · {l.billing_cycle}</Badge></TableCell>
                <TableCell className="text-right font-mono">₹{(l.total_price || 0).toLocaleString()}</TableCell>
                <TableCell className="font-mono text-xs">{(l.created_at || "").slice(0, 16).replace("T", " ")}</TableCell>
                <TableCell>
                  <Select value={l.status} onValueChange={(v) => update(l.id, v)}>
                    <SelectTrigger className="w-32" data-testid={`lead-status-${l.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
            {leads.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-muted-foreground py-10">No leads yet — the marketing site is hungry.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
